import { Flex, FlexProps, MoonIcon, SunIcon } from 'components'
import { useTheme } from 'utils'

export default function ColorModeSwitch() {
  const { theme, setTheme } = useTheme()

  return (
    <Flex
      alignItems="center"
      gap={1}
      cursor="pointer"
      onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
      borderRadius="14px"
      bg={theme === 'light' ? 'rgba(255, 255, 255, 0.70)' : 'rgba(255, 255, 255, 0.1)'}
      boxShadow="0px 7px 16px 0px rgba(0, 0, 0, 0.08)"
      p={1}
    >
      <Flex
        {...itemProps}
        bg={theme === 'light' ? 'rgba(60, 75, 211, 0.10)' : 'transparent'}
        color={theme === 'light' ? 'primary.500' : 'gray.600'}
      >
        <SunIcon fontSize="sm" />
      </Flex>
      <Flex
        {...itemProps}
        bg={theme === 'light' ? 'transparent' : 'rgba(255, 255, 255, 0.35)'}
        color={theme === 'dark' ? 'white' : 'gray.500'}
      >
        <MoonIcon fontSize="sm" />
      </Flex>
    </Flex>
  )
}

const itemProps: FlexProps = { borderRadius: '10px', p: 1.5 }
